import List from "../collections/list";
import Inventory from "../models/inventory";
import { excuseApi } from "../commons/http";

export default class Inventories extends List {
    constructor() {
        super();
        this.total = 0;
    }

    async fetchWithDate(page,per_page,start_date,end_date,transactionType){
        const res = await excuseApi({
            path: '/inventory_level_transactions',
            method: 'GET',
            params:{
                page: page,
                per_page: per_page,
                happened_at_start: start_date,
                happened_at_end: end_date,
                transaction_type: transactionType,
            }
        })
        console.log(res);
        if(res.status === 200){
            this.mapData(res.data.data);
            this.total = res.data.total;
        }
    }

    mapData(data = []){
        for (const item of data){
            const inventory = new Inventory();
            inventory.mapData(item);
            this.add(inventory);
        }
    }
}